export const HEADERS = [
	'No',
	'Email',
	'Market',
	'Type',
	'Entity name',
	'Sold date',
	'Refund date',
	'Total gross',
	'Invoice status',
	'Actions',
];

export const ACCEPTED_HEADERS = [
	'No',
	'Email',
	'Market',
	'Type',
	'Invoice number',
	'Entity name',
	'Issue date',
	'Sold date',
	'Refund date',
	'Total gross',
	'Status',
	'Actions',
];
